import React from 'react';
import { connectSearchBox } from 'react-instantsearch-dom';

const CustomSearchBox = connectSearchBox(({ currentRefinement, refine }) => (
  <form action="">
    <input
      autoComplete="off"
      onChange={(event) => refine(event.currentTarget.value)}
      placeholder="Enter location"
      type="search"
      value={currentRefinement}
    />
  </form>
));

export default CustomSearchBox;
